import { CreditCard, Plus, X, ChevronDown, ChevronUp } from "lucide-react";
import styles from "./ModalCartoes.module.scss";
import { ICartaoView, IInstallment } from "shared/interfaces/IMetodo";
import { useState } from "react";
import { buscarSimulacaoParcelas } from "shared/services/api/cartao.api";

export interface ICartao {
  id: string;
  brand: string;
  last4: string;
  holderName: string;
  default?: boolean;
}

interface ModalCartoesProps {
  open: boolean;
  cards: ICartaoView[];
  selectedCard?: string;
  total: number;
  onClose: () => void;
  onSelect: (
    card: ICartaoView,
    installment: IInstallment
  ) => void;
  onAddCard: () => void;
}

export const ModalCartoes = ({ open, cards, selectedCard, onClose, total, onSelect, onAddCard,}: ModalCartoesProps) => {
  const [expandedCard, setExpandedCard] = useState<string | null>(null);

  const [cardSelecionadoId, setCardSelecionadoId] = useState<
    string | undefined
  >(selectedCard);

  const [installments, setInstallments] = useState<IInstallment[]>([]);

  const [selectedInstallment, setSelectedInstallment] =
    useState<IInstallment | null>(null);

  const carregarParcelas = async () => {
    try {
      const parcelas = await buscarSimulacaoParcelas(total);
      setInstallments(parcelas);
    } catch (error) {
      console.error(error);
    }
  };

  const cardSelecionado = cards.find(
    (card) => card.id === cardSelecionadoId
  );

  if (!open) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h3>Meus Cartões</h3>

          <button className={styles.btnClose} onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <div className={styles.lista}>
          {cards.length === 0 && (
            <div className={styles.vazio}>
              <CreditCard size={40} />
              <p>Nenhum cartão cadastrado.</p>
            </div>
          )}

          {cards.map((card) => (
            <div key={card.id}>
              <div
                className={`${styles.card} ${
                  cardSelecionadoId === card.id ? styles.selected : ""
                }`}
              >
                <div
                  className={styles.cardHeader}
                  onClick={async () => {
                    const abrir = expandedCard !== card.id;

                    setCardSelecionadoId(card.id);
                    setExpandedCard(abrir ? card.id : null);

                    if (abrir) {
                      await carregarParcelas();
                    }
                  }}
                >
                  {card.defaultCard && (
                    <span className={styles.default}>Padrão</span>
                  )}

                  <div className={styles.info}>
                    <div className={styles.row}>
                      {card.bandeira && (
                        <img
                          src={card.bandeira}
                          alt={card.marca}
                          className={styles.bandeira}
                        />
                      )}

                      <strong>{card.marca}</strong>

                      <span className={styles.final}>
                        * {card.ultimos4digitos}
                      </span>

                      {expandedCard === card.id ? (
                        <ChevronUp
                          size={18}
                          className={styles.arrow}
                        />
                      ) : (
                        <ChevronDown
                          size={18}
                          className={styles.arrow}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {expandedCard === card.id && (
                <div className={styles.installments}>
                  {installments.map((item) => (
                    <div
                      key={item.installments}
                      className={`${styles.installment} ${
                        selectedInstallment?.installments ===
                        item.installments
                          ? styles.selectedInstallment
                          : ""
                      }`}
                      onClick={() => setSelectedInstallment(item)}
                    >
                      <div>
                        <strong>
                          {item.installments}x de R${" "}
                          {(item.installmentAmount / 100).toFixed(2)}
                        </strong>

                        <small>
                          Total R${" "}
                          {(item.totalAmount / 100).toFixed(2)}
                        </small>
                      </div>

                      <span>
                        {item.hasInterest
                          ? "Com juros"
                          : "Sem juros"}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        <button
          className={styles.add}
          onClick={onAddCard}
        >
          <Plus size={18} />
          Adicionar cartão
        </button>

        <div className={styles.footer}>
          <button
            className={styles.confirmar}
            onClick={() => {
              if (!cardSelecionado || !selectedInstallment) return;

              onSelect(cardSelecionado, selectedInstallment);
            }}
          >
            Confirmar
          </button>

          <button
            className={styles.cancelar}
            onClick={onClose}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};